<div class="container-fluid">
  <div class="row mt-5">
    <div class="card bg-card col-lg-3 pt-3 pb-3 px-3 col-md-6 col-12">
      <div class="d-flex justify-content-between">
        <div class="fs-16 font-white fw-normal">Students</div>
        <div class="d-flex new-add-btn px-1">
          <div [innerHtml]="SVG_ICONS.MEMBER_CHANGE_ICON() | sanitizer : 'html'"></div>
          <div class="font-dark-green fs-12 fw-bold ms-2 me-2">{{ newStudentCount }} New Added</div>
        </div>
      </div>
      <div class="mt-3 d-flex justify-content-between">
        <div class="fs-48 font-white fw-semibold">{{ studentCount || 0 }}</div>
        <div [innerHtml]="SVG_ICONS.RIGHT_ARROW() | sanitizer : 'html'" class="mt-4 cursor-pointer" routerLink="/members"></div>
      </div>
    </div>
    <div class="card bg-card col-lg-3 pt-3 pb-3 px-3 col-md-6 col-12">
      <div class="d-flex justify-content-between">
        <div class="fs-16 font-white fw-normal">Coach</div>
        <div class="d-flex new-add-btn px-1">
          <div [innerHtml]="SVG_ICONS.MEMBER_CHANGE_ICON() | sanitizer : 'html'"></div>
          <div class="font-dark-green fs-12 fw-bold ms-2 me-2">{{ newCoachCount }} New Added</div>
        </div>
      </div>
      <div class="mt-3 d-flex justify-content-between">
        <div class="fs-48 font-white fw-semibold">{{ trainers || 0 }}</div>
        <div [innerHtml]="SVG_ICONS.RIGHT_ARROW() | sanitizer : 'html'" class="mt-4 cursor-pointer" routerLink="/coach"></div>
      </div>
    </div>
    <div class="card bg-card col-lg-3 pt-3 pb-3 px-3 col-md-6 col-12">
      <div class="d-flex justify-content-between">
        <div class="fs-16 font-white fw-normal">Classes</div>
        <div class="d-flex new-add-btn px-1">
          <div [innerHtml]="SVG_ICONS.MEMBER_CHANGE_ICON() | sanitizer : 'html'"></div>
          <div class="font-dark-green fs-12 fw-bold ms-2 me-2">{{ newClassCount }} New Added</div>
        </div>
      </div>
      <div class="mt-3 d-flex justify-content-between">
        <div class="fs-48 font-white fw-semibold">{{ classCount || 0 }}</div>
        <div [innerHtml]="SVG_ICONS.RIGHT_ARROW() | sanitizer : 'html'" class="mt-4 cursor-pointer" routerLink="/class-list"></div>
      </div>
    </div>
    <div class="card bg-card col-lg-3 pt-3 pb-3 px-3 col-md-6 col-12">
      <div class="d-flex justify-content-between">
        <div class="fs-16 font-white fw-normal">Revenue (Current Month)</div>
        <!-- <div class="d-flex px-1" [ngClass]="revenueStatus === 'high' ? 'new-add-btn' : 'new-add-btn-red'">
          <div [innerHtml]="(revenueStatus === 'high' ? SVG_ICONS.MEMBER_CHANGE_ICON() : SVG_ICONS.MEMBER_CHANGE_ICON_DECREASE()) | sanitizer : 'html'"></div>
          <div class="fs-12 fw-bold ms-2 me-2" [ngClass]="revenueStatus === 'high' ? 'font-dark-green' : 'font-red-light'">{{ revenuePercentage }}%</div>
        </div> -->
      </div>
      <div class="mt-5 d-flex justify-content-between">
        <div class="fs-27 font-white fw-semibold">₹ {{ studentRevenue || 0 }}</div>
        <div [innerHtml]="SVG_ICONS.RIGHT_ARROW() | sanitizer : 'html'" class="mt-2 cursor-pointer" routerLink="/finance"></div>
      </div>
    </div>
  </div>
  <div class="row">
    <div class="col-md-9 col-12 mt-5">
      @if(upcomingClass){
      <div class="card bg-card-secondary border-radius-10 p-2 mb-2">
        <div class="d-flex justify-content-between align-items-center">
          <div class="d-flex align-items-center">
            <div class="fs-16 fw-bold font-white">Upcoming Class</div>
          </div>
          <div class="fs-12 fw-bold font-white px-2 py-1 border-radius-5 border-gray bg-main-container">
            {{ upcomingClass.displayDate }}
          </div>
        </div>
        <div class="card bg-card-inner border-radius-10 p-2 mt-2">
          <div class="d-flex justify-content-between align-items-center">
            <div>
              <div class="fs-16 fw-bold font-white">{{ upcomingClass.title }}</div>
              <div class="fs-14 fw-normal font-white mt-1">{{ upcomingClass.displayStartTime }} - {{ upcomingClass.displayEndTime }}</div>
              <div class="fs-12 font-gray mt-1">{{ upcomingClass.CenterName }}</div>
            </div>
            <div>
              <button
                class="border-radius-5 px-2 py-1 border-gray bg-main-container"
                [class.cursor-pointer]="upcomingClass.isAttendanceEnabled"
                [class.cursor-not-allowed]="!upcomingClass.isAttendanceEnabled"
                [style.opacity]="upcomingClass.isAttendanceEnabled ? '1' : '0.5'"
                [disabled]="!upcomingClass.isAttendanceEnabled"
                matTooltip="Take attendance"
                matTooltipPosition="below"
                matTooltipShowDelay="0"
                (click)="onAttendance(upcomingClass.classId)">
                <div [innerHTML]="SVG_ICONS.ATTENDENCE_TAKE_ICON() | sanitizer : 'html'" style="transform: scale(0.8)"></div>
              </button>
            </div>
          </div>
        </div>
      </div>
      }
      <div class="">
        <div class="calendar-container bg-dark flex-column d-flex overflow-hidden border-gray">
          <div class="calendar-controls d-flex align-items-center justify-content-between flex-wrap gap-3 p-3 border-bottom">
            <div class="d-flex align-items-center">
              <button class="tab-btn font-blue fs-25 fw-semibold border-0 bg-none" [class.active]="activeTab === 'calendar'" (click)="setActiveTab('calendar')">Schedule</button>
            </div>

            <div class="view-switcher">
              <button [class.active]="currentView === 'day'" (click)="setView('day')">Day</button>
              <button [class.active]="currentView === 'week'" (click)="setView('week')">Week</button>
              <button [class.active]="currentView === 'month'" (click)="setView('month')">Month</button>
            </div>

            <div class="date-nav d-flex align-items-center gap-3">
              <button class="nav-arrow" (click)="navigateDate(-1)">‹</button>
              <button class="today-btn" (click)="goToToday()">Today</button>
              <button class="nav-arrow" (click)="navigateDate(1)">›</button>
              <span class="current-date-label font-white fs-18 fw-bold text-center">{{ monthAndYearDisplay }}</span>
            </div>
          </div>

          <div class="calendar-scroll-area">
            <ng-container *ngIf="currentView === 'week' || currentView === 'day'">
              <div class="week-view-layout position-relative d-flex">
                <div class="time-column">
                  <div class="corner-cell"></div>
                  <div class="d-flex align-items-center justify-content-center font-gray fs-12 border-bottom" style="height: 80px" *ngFor="let hour of timeSlots">{{ hour }}</div>
                </div>

                <div class="d-flex flex-column flex-1">
                  <div class="header-row d-flex">
                    <div class="day-header d-flex align-items-center flex-column justify-content-center" *ngFor="let day of weekDays" [class.today]="isToday(day.fullDate)">
                      <span class="fs-12 mb-2 font-gray fw-bold">{{ day.name }}</span>
                      <span class="day-number fs-18 fw-bold font-white">{{ day.number }}</span>
                    </div>
                  </div>

                  <div class="grid-body">
                    <div class="day-col" *ngFor="let day of weekDays; let i = index">
                      <div class="grid-line" *ngFor="let hour of timeSlots"></div>

                      <div class="events-layer">
                        <div *ngFor="let group of getGroupedEventsForDay(i)" class="event-group" [style.top.px]="group.top" [style.height.px]="group.height">
                          <div class="event-card w-100 h-100 border-radius-5 overflow-hidden cursor-pointer p-1 position-relative" [style.border-left-color]="group.events[0].color">
                            <div class="font-white fs-14 fw-semibold overflow-hidden text-overflow-ellipsis">{{ group.events[0].title }}</div>
                            <div class="font-gray fs-12">{{ group.events[0].displayStartTime }} - {{ group.events[0].displayEndTime }}</div>
                            <div class="font-gray fs-12">{{ group.events[0].CenterName }}</div>
                            <div *ngIf="group.events.length > 1" class="more-tag">+{{ group.events.length - 1 }}</div>
                            <div
                              class="attendance-icon-overlay position-absolute top-0 end-0 p-1"
                              *ngIf="isAttendanceActive(group.events[0], day.fullDate)"
                              (click)="$event.stopPropagation(); onAttendance(group.events[0].classId)">
                              <div [innerHtml]="SVG_ICONS.ATTENDENCE_TAKE_ICON() | sanitizer : 'html'" style="transform: scale(0.8)"></div>
                            </div>
                          </div>

                          <div *ngIf="group.events.length > 1" class="popover-box border-radius-5 position-absolute">
                            @for(evt of group.events; track $index){
                            <div class="popover-item mb-2 d-flex align-items-center gap-2">
                              <span class="border-radius-50" [style.background]="evt.color" style="width: 8px; height: 8px"></span>
                              <span class="font-white fs-12 fw-bold">{{ evt.title }}</span>
                              <span class="fs-10 font-gray fw-bold">{{ evt.displayStartTime }} - {{ evt.displayEndTime }}</span>
                              <!-- <div class="p-center">{{ evt.CenterName }}</div> -->
                            </div>
                            }
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </ng-container>

            <ng-container *ngIf="currentView === 'month'">
              <div class="month-view-layout">
                <div class="month-header-row d-flex d-flex">
                  <div *ngFor="let d of ['SUN', 'MON', 'TUE', 'WED', 'THU', 'FRI', 'SAT']" class="month-header-cell p-3 text-center font-gray fs-12 fw-semibold">
                    {{ d }}
                  </div>
                </div>

                <div class="month-body">
                  <div *ngFor="let week of monthGrid" class="month-week-row d-flex">
                    <div *ngFor="let day of week" class="month-day-cell d-flex flex-column" [class.dimmed]="!day.isCurrentMonth">
                      <div class="d-flex justify-content-flex-end mb-1">
                        <span class="date-num fs-12 font-white fw-bold d-flex align-items-center justify-content-center border-radius-50" [class.today-circle]="isToday(day.date)">{{ day.day }}</span>
                      </div>

                      <div class="d-flex flex-column gap-2">
                        <div
                          *ngFor="let evt of day.events.slice(0, 3)"
                          class="fs-12 font-white border-radius-5 p-1 overflow-hidden cursor-pointer fs-semibold position-relative event-month-item"
                          [style.background-color]="evt.color">
                          {{ evt.title }}
                          <div
                            class="attendance-icon-overlay position-absolute top-0 end-0 p-1"
                            *ngIf="isAttendanceActive(evt, day.date)"
                            (click)="$event.stopPropagation(); onAttendance(evt.classId)">
                            <div [innerHtml]="SVG_ICONS.ATTENDENCE_TAKE_ICON() | sanitizer : 'html'" style="transform: scale(0.6)"></div>
                          </div>
                        </div>
                        <div *ngIf="day.events.length > 3" class="fs-10 font-gray text-right mt-1">+{{ day.events.length - 3 }} more</div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </ng-container>
          </div>
        </div>
      </div>
    </div>
    <div class="col-md-3 col-12 mt-5 bg-card p-4">
      <div class="fs-18 fw-bold font-white">Updates</div>
      <div class="fs-14 fw-normal font-white">All new and crucial update will be shown here.</div>
      <div class="updates-scroll-container">
        @if(studentExpiryDetailsToday.length > 0){ @for(student of studentExpiryDetailsToday; track $index){
        <div class="card bg-card-secondary border-radius-10 p-3 mt-3">
          <div class="d-flex justify-content-between">
            <div [innerHtml]="SVG_ICONS.FINANCE('var(--font-color-white)') | sanitizer : 'html'"></div>
            <div class="fs-16 fw-bold font-white">
              <button class="due-btn px-3">{{ student.Status }}</button>
            </div>
          </div>
          <div class="card bg-card-inner border-radius-10 p-3 mt-3 mb-3">
            <div class="d-flex justify-content-between">
              <div>
                <div class="fs-16 fw-bold font-white">{{ student.StudentName }} ({{ student.CenterName }})</div>
                <div class="fs-14 fw-normal font-white d-flex align-items-center">
                  <div [innerHtml]="SVG_ICONS.CALL_ICON() | sanitizer : 'html'"></div>
                  <a href="tel: +91 {{ student.StudentMobileNo }}" class="font-white fs-14 fw-normal text-decoration-none">+91 {{ student.StudentMobileNo }}</a>
                </div>
              </div>
              <!-- <div [innerHtml]="SVG_ICONS.RIGHT_ARROW('var(--font-color-gray)') | sanitizer : 'html'" class="mt-2 cursor-pointer" (click)="onStudentDetails(student.StudentID)" tabindex="0" (keydown)="onStudentDetails(student.StudentID)"></div> -->
            </div>
          </div>
          <div class="d-flex gap-4">
            <div class="d-flex align-items-center">
              <div [innerHtml]="SVG_ICONS.MEMBER_ICON('var(--font-color-dark-green)') | sanitizer : 'html'"></div>
              <div class="ms-2 fs-14 fw-bold font-white">{{ student.PackageName }}</div>
            </div>
            <!-- <div class="d-flex align-items-center">
                <div [innerHtml]="SVG_ICONS.PRICE_ICON() | sanitizer : 'html'"></div>
                <div class="ms-2 fs-14 fw-bold font-white">₹ {{student.PackageAmount}}</div>
              </div> -->
          </div>
        </div>
        } } @if(studentExpiryDetailsSoon.length > 0){ @for(student of studentExpiryDetailsSoon; track $index){
        <div class="card bg-card-secondary border-radius-10 p-3 mt-3">
          <div class="d-flex justify-content-between">
            <div [innerHtml]="SVG_ICONS.FINANCE('var(--font-color-white)') | sanitizer : 'html'"></div>
            <div class="fs-16 fw-bold font-white">
              <button class="due-btn px-3">{{ student.Status }}</button>
            </div>
          </div>
          <div class="card bg-card-inner border-radius-10 p-3 mt-3 mb-3">
            <div class="d-flex justify-content-between">
              <div>
                <div class="fs-16 fw-bold font-white">{{ student.StudentName }} ({{ student.CenterName }})</div>
                <div class="fs-14 fw-normal font-white d-flex align-items-center">
                  <div [innerHtml]="SVG_ICONS.CALL_ICON() | sanitizer : 'html'"></div>
                  <div class="ms-2 fs-12 fw-bold font-white">{{ student.StudentMobileNo }}</div>
                </div>
              </div>
              <div
                [innerHtml]="SVG_ICONS.RIGHT_ARROW('var(--font-color-gray)') | sanitizer : 'html'"
                class="mt-2 cursor-pointer"
                (click)="onStudentDetails(student.StudentID)"
                tabindex="0"
                (keydown)="onStudentDetails(student.StudentID)"></div>
            </div>
          </div>
          <div class="d-flex gap-4">
            <div class="d-flex align-items-center">
              <div [innerHtml]="SVG_ICONS.MEMBER_ICON('var(--font-color-dark-green)') | sanitizer : 'html'"></div>
              <div class="ms-2 fs-14 fw-bold font-white">{{ student.PackageName }}</div>
            </div>
            <!-- <div class="d-flex align-items-center">
              <div [innerHtml]="SVG_ICONS.PRICE_ICON() | sanitizer : 'html'"></div>
              <div class="ms-2 fs-14 fw-bold font-white">₹ {{student.PackageAmount}}</div>
            </div> -->
          </div>
        </div>
        } } @if(studentExpiryDetailsToday.length === 0 && studentExpiryDetailsSoon.length === 0){
        <div class="fs-16 mt-3 fw-bold font-red-light">No Updates</div>
        }
      </div>
    </div>
  </div>
</div>
